import * as React from 'react';

/**
 * Size of the area a phone keyboard leaves visible. iOS shrinks the visual viewport rather than the
 * layout viewport, so a `position: fixed` full-screen composer keeps its original height and its
 * header and send bar end up behind the keyboard, with no way back. Feeding these values to the
 * composer's `--composer-viewport-*` custom properties keeps it inside what the user can see.
 *
 * Returns null when the fit is not needed (desktop) or unavailable (no `visualViewport`), which
 * leaves the stylesheet's own fallback in place.
 */
export const useComposerViewportFit = (enabled: boolean) => {
	const [fit, setFit] = React.useState<{ top: number; height: number } | null>(null);

	React.useEffect(() => {
		const viewport = enabled ? window.visualViewport : null;
		if (!viewport) {
			setFit(null);
			return;
		}
		const update = () => setFit({ top: viewport.offsetTop, height: viewport.height });
		update();
		viewport.addEventListener('resize', update);
		viewport.addEventListener('scroll', update);
		return () => {
			viewport.removeEventListener('resize', update);
			viewport.removeEventListener('scroll', update);
		};
	}, [enabled]);

	return fit;
};
